
<div *ngIf="healthChecks.length" class="overdue-health-check-list">
  <div class="overdue-health-check-list-row">
    <div></div>
    <div></div>
    <div class="time-header medium-data">overdue by:</div>
  </div>

  <div *ngFor="let healthCheck of healthChecksSorted" class="overdue-health-check-list-row">
    <div class="name">{{healthCheck.name}}</div>
    <div>{{healthCheck.site}}</div>
    <div class="time" [ngClass]="healthCheck.colorClass">{{healthCheck.duration}}</div>
  </div>
</div>
<div *ngIf="!healthChecks.length">
  {{ emptyStateText }}
</div>
